//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

//*******************Demo pattern of objects****************
// {
//   img:
//     "https://drive.google.com/uc?export=view&id=",
//   frame: "",
//   location: "",
// },

export const landscapeURLs = [
  {
    img:
      "https://drive.google.com/uc?export=view&id=10sIK4FeLdss_FewHosi-aJs1VFJr6gjc",
    frame: "Sunset view from terrace",
    location: "TinselTown, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10sCWGuA648ARQU2Lpcm4zn3btwf0xzYZ",
    frame: "Sunset view from terrace",
    location: "TinselTown, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10n_Q54vXcsrpN-yEkNeFzmP56E6BOpr_",
    frame: "Sunset view from terrace",
    location: "TinselTown, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=110NDvsAf2UIwXm_fSCMaOh-aUrziXCSW",
    frame: "Sunset view from terrace",
    location: "TinselTown, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10xs5r9JYOfVg-Vdh7-wNJea_o94RrW0O",
    frame: "Sunset view from terrace",
    location: "TinselTown, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=113It8sv42ab4uVEg9g35WDKInEcv7NRL",
    frame: "A view from guest house",
    location: "Infosys, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11B9UwqmJ3JsCNTi32j8wWU5SniUl-7AH",
    frame: "A view from guest house",
    location: "Infosys, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=113Xxv8wENvNkHVNBRQHy99IAJE7dWMTZ",
    frame: "A view from guest house",
    location: "Infosys, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=115AI_s1_plU8AR01gfeoWMIYZkdEOxsq",
    frame: "A view from guest house",
    location: "Infosys, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11ISvCw3WpNBVdQ0F0Te2BI2KaV0OJNSd",
    frame: "Global Education Center",
    location: "Infosys, Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11MmcHWKmvVMotR1JENrb8JWCwXgmXgJB",
    frame: "Swimming pool",
    location: "Infosys, Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11Nv_WaB-eWlZHm3bfWdPe8gYugxwN2-Q",
    frame: "Swimming pool",
    location: "Infosys, Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11TfDojE1YpkSFve4Gv7ouSjPMIHdCFKM",
    frame: "Global Education Center",
    location: "Infosys, Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11WbfCQxRcqrLB4HnAXbzk5181ba7SbIW",
    frame: "Race course and multiplex",
    location: "Infosys, Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11Xhc_OF6zCB7xygG8sCGG4VwWfOFEFBM",
    frame: "Global Education Center",
    location: "Infosys, Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11aNL44yU-CDuGGiLJF_ZmyA-3ijXNgWB",
    frame: "Swimming pool",
    location: "Infosys, Mysore, Karnataka, India",
  },
];
